import React from 'react';
import { Redirect } from 'react-router';

import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import Link from '@material-ui/core/Link';
import PeopleIcon from '@material-ui/icons/People';
import Typography from "@material-ui/core/Typography";
import VisibilityIcon from '@material-ui/icons/VisibilityOutlined';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOffOutlined';

import Api from '../../../../../../common/api'
import Auth from '../../../../../../common/auth'
import Local from '../../../../../../common/local'
import Util from '../../../../../../common/util';
import Recaptcha from '../../../../../../common/components/recaptcha';

import CurrentUser from '../../../../shared/components/current-user';
import Heading from '../../../../shared/components/heading';
import LeftRail from '../../../../shared/components/left-rail';
import PageHeader from '../../../../shared/components/page-header';
import StandardInput from '../../../../shared/components/gn-standard-input';
import withTranslations from '../../../../../../common/components/with-translations';

const styles = (theme) => ({
  view: {
    ...theme.internalContainer,
    [theme.breakpoints.up('md')]: {
      padding: theme.internalContainer._themeMdPadding
    },
  },
  button: {
    borderRadius: '9999px',
    fontWeight: '600',
    fontSize: '16px',
    height: '55px',
    width: '100%',
  },
  buttonHover: {
    '&:hover': {
      backgroundColor: 'var(--button-hover-color) !important'
    },
  },
  buttonControls: {
    display: "flex",
    justifyContent: "center",
    marginTop: "15px"
  },
  noHeaderContainer: {
    padding: '20px 20px 0px 20px',
    maxWidth: '1200px',
    margin: '0 auto 50px auto'
  },
  stepTitle: {
    display: "flex",
    justifyContent: "center",
    fontWeight: '600',
    fontSize: '1.2rem',
    marginBottom: '10px',
  }
});

class StepEmailEntry extends React.Component {

  constructor(props) {

    super(props);

    this.state = {
      processing: false,
      username: '',
      validation: {
        username: null
      }
    };

    this.api = new Api();
    this.generateOnInput = this.generateOnInput.bind(this);
    this.onError = this.onError.bind(this);
    this.onCheckEmail = this.onCheckEmail.bind(this);
    this.onSubmitPressed = this.onSubmitPressed.bind(this);
  }

  generateOnInput(stateKey) {

    return function (e) {

      this.setState({
        [stateKey]: e.target.value,
        validation: { username: null, password: null }
      });
    }.bind(this);
  }

  onError(err) {

    this.setState({ processing: false });
    this.props.onError(err);
  }

  async onCheckEmail() {
    const { t } = this.props;
    const {
      username
    } = this.state;

    const validation = {
      username: username === '' ? t('stepEmailEntry.requiredEmailError') : null
    };

    if (Object.values(validation).some((v) => { return v !== null; })) {
      return this.setState({ validation });
    }

    this.setState({ processing: true });
    const exists = await Auth.emailHasAccount(username);
    this.setState({ processing: false });

    if (exists === null) {
      validation.username = t('stepEmailEntry.validEmailError');
      this.setState({ validation });

      return;
    }

    this.props.onEmailAccountCheck(username, exists);
  }

  async onSubmitPressed(e) {

    if (e.key === 'Enter') {
      e.preventDefault();
      await this.onCheckEmail();
    }
  }

  render() {
    const { t } = this.props;
    const containerStyle =
      this.props.query.noHeader ?
        this.props.classes.noHeaderContainer :
        this.props.classes.view;

    const emailInput = (
      <Grid item xs={12} md={12}>
        <StandardInput
          inputType="email"
          value={this.state.username}
          style={{ marginBottom: '15px' }}
          error={this.state.validation.username}
          attribute="username"
          label={t('stepEmailEntry.emailLabel')}
          labelWidth={85}
          onChange={this.generateOnInput('username')}
          onKeyUp={this.onSubmitPressed} />
      </Grid>
    );

    const displayableContent = this.props.application && this.props.application.displayable && this.props.application.displayable.content
      ? this.props.application.displayable.content
      : {};

    const buttonColor = displayableContent.buttonColor || (this.props.query.buttonColor && `#${this.props.query.buttonColor}`);
    const buttonHoverColor = displayableContent.buttonHoverColor || (this.props.query.buttonHoverColor && `#${this.props.query.buttonHoverColor}`);

    const buttonStyle = {
      ...(buttonColor && { backgroundColor: buttonColor }),
      ...(buttonHoverColor && { '--button-hover-color': buttonHoverColor }),
    };

    const buttonClassName = buttonHoverColor ?
      `${this.props.classes.button} ${this.props.classes.buttonHover}` :
      this.props.classes.button;

    const bottomControls = (
      <Grid className={this.props.classes.buttonControls} item xs={12}>
        <Button style={buttonStyle} className={buttonClassName} color="primary" onClick={this.onCheckEmail} variant="contained" id="checkEmail">
          {this.state.processing ?
            (<CircularProgress size={14} color="inherit" />)
            : t('stepEmailEntry.continueButton')
          }
        </Button>
      </Grid>
    );

    const stepTitle = this.props.query.showSteps === 'true' ? (
      <Grid className={this.props.classes.stepTitle} item xs={12}>
        <Typography className={this.props.classes.stepTitle}>
          {t('stepEmailEntry.stepTitle')}
        </Typography>
      </Grid>
    ) : null;

    return (
      <Grid container spacing={1} className={containerStyle} >
        {stepTitle}
        {emailInput}
        {bottomControls}
      </Grid>
    );
  }
}

export default withTranslations(withStyles(styles)(StepEmailEntry));
